/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
export enum BookingSessionStatus {
  InitiatingPayment = 0,
  PaymentInProgress = 1,
  PaymentFailed = 2,
  BookingInProgress = 3,
  BookingCompleted = 4,
  BookingFailed = 5,
  RefundInProgress = 6,
  Refunded = 7
}
